// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalSecondary_backdrop__WcrNM","modal":"ModalSecondary_modal__Dt3N6","modal--read":"ModalSecondary_modal--read__xCrr-"};